//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import ReactDOM from "react-dom";
import LoaderApplication from "src/components/loader/LoaderApplication";
import "bootstrap/dist/css/bootstrap.min.css";
import {HashRouter as Router} from "react-router-dom";

function App() {
  return <Router>
    <LoaderApplication/>
  </Router>;
}

ReactDOM.render(<App />, document.getElementById("root"));
